// removed by extract-text-webpack-plugin
module.exports = {"root":"index__root__4PyOE"};


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 138
// module chunks = 2